export default function getCookiesOption() {
  const originReg
    = /^https?:\/\/[\w\d-]*\.?((hik-proconnect|pramaonlinepro|hik-proconnectru|hik-partner|hik-partnerru).com)(:\d{2,})?$/;
  let option = {};
  const match = window.location.origin.match(originReg);
  if (match) {
    option = {
      path: '/',
      domain: `.${match[1]}`
    };
  }
  return option;
}
